export const CURRENCY = 'د.ا';

export function formatMoney(value) {
  const n = Number(value) || 0;
  return `${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${CURRENCY}`;
}

export function formatNumber(value) {
  return (Number(value) || 0).toLocaleString('en-US');
}

export function formatDate(value, options = { year: 'numeric', month: 'long', day: 'numeric' }) {
  return new Date(value).toLocaleDateString('ar-EG', options);
}

// yyyy-mm-dd in local time, the format <input type="date"> expects.
export function toInputDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export const SOURCE_LABELS = {
  all: 'كل المصادر',
  pos: 'نقطة البيع',
  mondoway: 'مندواي',
};

// Havana browns and golds first, then distinct supporting hues so neighbouring
// slices stay distinguishable.
export const CATEGORY_COLORS = [
  '#6B4A2E', '#D7B032', '#2E7D6B', '#B8935A', '#A0522D',
  '#5B6C8F', '#C2703D', '#7A8450', '#9E4F5C', '#8F6A1B',
];

export const categoryColor = (index) => CATEGORY_COLORS[index % CATEGORY_COLORS.length];
